module.exports = __webpack_public_path__ + "img/2_211.4a8479c0.png";